import React from 'react';
import { API_BASE_URL } from '../services/api';

const DebugInfo: React.FC = () => {
  const isLocal = API_BASE_URL.includes('localhost');
  
  return (
    <div className={`fixed top-4 right-4 p-3 rounded-lg text-sm z-50 ${
      isLocal ? 'bg-green-900 text-green-200' : 'bg-red-900 text-red-200'
    }`}>
      <div className="font-bold mb-1">
        {isLocal ? '🟢 LOCAL' : '🔴 PRODUCTION'} Backend
      </div>
      <div className="text-xs opacity-80">
        {API_BASE_URL}
      </div>
      <div className="text-xs opacity-60 mt-1">
        NODE_ENV: {process.env.NODE_ENV}
      </div>
    </div>
  );
};

export default DebugInfo;